<template>
  <div class="columns">
    <div class="is-half column">
      <article class="tile is-child box" v-if="account">
        <div class="columns">
          <div class="column is-10"><h4 class="title"><strong>Finances</strong> Account #{{account.id}} - {{getCustomer()}}</h4></div>
          <div class="column is-2" style="text-align: right;"><a :class="{'button': true, 'is-success': true, 'is-disabled': inProgress, 'is-loading': inProgress}" @click="addCredit()">Add Credit</a></div>
        </div>
        <div class="columns">
          <div class="column is-12">
            <table class="table is-bordered is-striped is-narrow">
              <thead>
                <tr>
                  <td>#</td>
                  <td>Currency</td>
                  <td>Created At</td>
                  <td>Last Transaction</td>
                  <td>Total</td>
                  <td>Action</td>
                </tr>
              </thead>
              <tbody>
                <tr v-for="account_sub in account.accounts_sub">
                  <td>{{account_sub.id}}</td>
                  <td>{{account_sub.currency}}</td>
                  <td>{{account_sub.created_at}}</td>
                  <td>{{account_sub.updated_at}}</td>
                  <td>{{account_sub.total}}</td>
                  <td style="text-align: center;">
                    <tooltip label="Transfer Credit" type="default" placement="left">
                      <a class="button button-table is-small" @click="transferCredit(account_sub)">
                        <i class="fa fa-exchange"></i>
                      </a>
                    </tooltip>
                    <tooltip label="Transactions" type="default" placement="left">
                      <a class="button button-table is-small" @click="viewTransactions(account_sub)">
                        <i class="fa fa-list-alt"></i>
                      </a>
                    </tooltip>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </article>
    </div>
    <div class="is-half column">
      <article class="tile is-child box" v-if="transactions">
        <div class="columns">
          <div class="column is-12"><h4 class="title">Last Transactions</h4></div>
        </div>
        <div class="columns">
          <div class="column is-12">
            <table class="table is-bordered is-striped is-narrow">
              <thead>
                <tr>
                  <td>#</td>
                  <td>Account Sub</td>
                  <td>User</td>
                  <td>Transaction</td>
                  <td>Payment Method</td>
                  <td>Date</td>
                  <td>Type</td>
                  <td>Value</td>
                  <td>Currency</td>
                </tr>
              </thead>
              <tbody>
                <tr v-for="transaction in transactions">
                  <td>{{transaction.id}}</td>
                  <td>{{transaction.account_sub_id}}</td>
                  <td>{{transaction.user.name}}</td>
                  <td>{{transaction.transaction}}</td>
                  <td>{{parsePaymentMethod(transaction.payment_method)}}</td>
                  <td>{{transaction.created_at}}</td>
                  <td>{{parseTransactionType(transaction.transaction_type)}}</td>
                  <td>{{transaction.value}}</td>
                  <td>{{transaction.currency}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </article>
    </div>
  </div>
</template>

<script>
  import Account from '../../components/finances/account'
  import HyperTable from '../../components/hyper-table/HyperTable.vue'
  import Datepicker from 'vue-bulma-datepicker'
  import message from '../../utils/message'
  import vSelect from 'vue-select'
  import Tooltip from 'vue-bulma-tooltip'
  export default {
    data () {
      return {
        account: null,
        transactions: null,
        inProgress: false
      }
    },
    beforeMount () {
    },
    mounted () {
      this.$nextTick(() => {
        this.loadData()
        this.loadTransactions()
      })
    },
    watch: {
      '$route' (to, from) {
        this.clear(false)
      }
    },
    methods: {
      message (type, title, content) {
        let propsData = {
          title: title,
          message: content,
          type: type,
          direction: 'down',
          duration: 4500,
          showCloseButton: true
        }
        message.openMessage(propsData)
      },
      parsePaymentMethod (method) {
        if ((method !== null) && (method !== undefined)) {
          let methodName = ''
          if (parseInt(method.method_type) === 1) {
            methodName = 'CARD - ' + method.card_number + ' - ' + method.card_flag
          } else {
            methodName = 'BANK - ' + method.bank
            if (method.account !== null) {
              methodName = methodName + ' - ' + method.account
            }
            if (method.agency !== null) {
              methodName = methodName + ' - ' + method.agency
            }
          }
          return methodName
        } else {
          return ''
        }
      },
      addCredit () {
        let propsData = {
          context: this,
          account_id: this.account.id,
          callback: 'addCreditCallback'
        }
        Account.openAccountAddCredit(propsData)
      },
      addCreditCallback () {
        this.loadData()
        this.loadTransactions()
      },
      parsePrice (content) {
        return content[0] + ' ' + content[1]
      },
      getCustomer () {
        if (this.account.base !== null) {
          return this.account.base.name + ' (base)'
        } else {
          return this.account.agency.name + ' (agency)'
        }
      },
      parseTransactionType (type) {
        if (parseInt(type) === 1) {
          return 'Credit'
        } else if (parseInt(type) === 2) {
          return 'Debit'
        } else if (parseInt(type) === 3) {
          return 'Transfer'
        }
      },
      loadData () {
        this.$http.get(this.$store.state.config.apiURL + '/account/' + this.$route.params.id).then((response) => {
          this.account = response.body
        }, (response) => {
        })
      },
      loadTransactions () {
        this.$http.get(this.$store.state.config.apiURL + '/account/' + this.$route.params.id + '/transactions').then((response) => {
          this.transactions = response.body
        }, (response) => {
        })
      },
      viewTransactions (accountSub) {
        let propsData = {
          context: this,
          account_id: this.account.id,
          account_sub_id: accountSub.id
        }
        Account.openAccountSubTransactions(propsData)
      },
      transferCredit (accountSub) {
        let propsData = {
          context: this,
          account_sub: accountSub,
          callback: 'transferCreditCallback'
        }
        Account.openAccountSubTransferCredit(propsData)
      },
      transferCreditCallback () {
        this.loadData()
        this.loadTransactions()
      }
    },
    components: {
      HyperTable,
      Datepicker,
      vSelect,
      Tooltip
    }
  }
</script>

<style lang="scss" scoped>
  .is-title {
    text-transform: capitalize;
  }
  .searchable {
    width: 450px;
  }
</style>



// WEBPACK FOOTER //
// AccountsSub.vue?133737a3